<template>
<nav class="navbar" :style="{ background: data.brand.whitelabel_config.headerBackgroundColor }">
        <div class="container-fluid container" >
          <span class="navbar-image"
          :style="{ textAlign: data.brand.whitelabel_config.logoPosition }"><img v-if="data.brand.whitelabel_config.header_logo !== null"
              :src="apiUrlStorage + data.brand.whitelabel_config.header_logo" width="120" />
          </span>
        </div>
      </nav> 
</template>


<script>
import { mapActions } from "vuex";

export default {

    props: ['data', 'apiUrlStorage'],

    methods: {
        ...mapActions(['reloadToPath']),

  }
};
</script>

<style scoped>
.navbar {
  border-bottom: 0.5px solid;
  /* height: 80px; */
  /* color: #000000; */
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 30px 0;
}

.navbar .navbar-image {
  width: 100%;
  text-align: center;

}

.navbar .navbar-image img {
  height: auto;
  width: 200px;
  object-fit: contain
}
</style>